<template>
  <section class="address-list">
    <ServerDeleteConfirm
      v-if="deleteConfirm.opened"
      :selected-count="rowsSelected.length"
      :loading="deleteConfirm.loading"
      @approve="onDeleteConfirm"
      @close="onDeleteClose"
    />
    <div class="address-list__filters">
      <Filters
        :model-value="filtersActive"
        :filters="filters"
        @update:modelValue="onFiltersChange"
      />
    </div>
    <div class="address-list__list">
      <Table
        v-model="rowsSelected"
        :columns="tableColumns"
        :rows="tableRows"
        @rowClick="onRowClick"
      />
      <Pagination
        v-model="currentPage"
        v-bind="pagination"
        @switchPage="onSwitchPage"
      />
    </div>
    <div class="address-list__actions">
      <Actions
        :actions="rowsSelected.length ? actions.selected : actions.default"
      />
    </div>
  </section>
</template>

<script>
import Filters from '../../components/Filters.vue'
import Table from '../../components/Table.vue'
import Actions from '../../components/Actions.vue'
import MeterConfigServerList from '../../mixins/Mock/MeterConfigServerList.js'
import MockPagination from '../../mixins/Mock/MockPagination.js'
import Pagination from '../../components/Pagination.vue'
import ServerDeleteConfirm from '../Popup/ServerDeleteConfirm.vue'

export default {
  name: 'AddressList',
  mixins: [MeterConfigServerList, MockPagination],
  components: { Filters, Table, Actions, Pagination, ServerDeleteConfirm },
  data() {
    return {
      filtersActive: {},
      rowsSelected: [],
      deleteConfirm: {
        opened: false,
        loading: false,
      },
    }
  },
  methods: {
    openDeleteModal() {
      this.deleteConfirm.opened = true
    },
    onDeleteClose() {
      this.deleteConfirm.opened = false
    },
    onDeleteConfirm() {
      this.deleteConfirm.loading = true
      this.serverService
        .removeServers(this.rowsSelected)
        .then(() => {
          this.$store.dispatch('setNotification', {
            text: 'Серверы успешно удалены.',
          })
          this.rowsSelected = []
          this.deleteConfirm.opened = false
          this.deleteConfirm.loading = false
          this.getFilteredServers()
        })
        .catch(error => {
          console.log(error)
          this.deleteConfirm.loading = false
        })
    },
    onFiltersChange(value) {
      this.filtersActive = value
      const filters = Object.fromEntries(
        Object.entries(value).filter(
          ([, v]) => v !== null && v !== undefined && v !== ''
        )
      )
      this.filterServers(filters)
    },
  },
}
</script>

<style lang="scss" scoped>
.address-list {
  &__filters {
    margin: 0px $space-md $space-lg;
  }

  &__list {
    margin: 0px $space-md $space-lg;
  }
}
</style>
